import React, { useContext, useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/react-hooks";
import Queries from "../Queries";
import { GlobalContext } from "./../Context";
import "./ServiceType.scss";

export const ServiceType = ({ data, isResultView = false }) => {
  const globalContext = useContext(GlobalContext);
  const {
    langcode,
    advancedFiltersVisibility,
    setAdvancedFiltersVisibility,
    setCurrentPopUp,
    mapsInstance,
    initialPos,
    radius,
    setBranches,
    setFiltersVisibility,
    setResultsState,
    setMarkersVisibility,
    setActiveFilters,
    setBranchSchedulesVisibility,
    categoryFilters,
    setCategoryFilters,
    categorySelected,
    setCategorySelected,
  } = globalContext;

  const [, setQueryState] = useState("waiting");
  const [tids, setTids] = useState("");
  const [getBranches, queryResult] = useLazyQuery(Queries("branches"), {
    variables: {
      langcode: langcode,
      tids: tids,
      field_coordinates_proximity: `${initialPos.lat},${initialPos.lng}<${
        radius / 1000
      }km`,
    },
  });

  const handleService = (category) => {
    if (category === categorySelected) {
      setCategorySelected(null);
      setTids("");
      setActiveFilters([]);
      if (isResultView === false) {
        setBranchSchedulesVisibility(false);
        return;
      }
    } else {
      setCategorySelected(category);
      if (isResultView) {
        const categoryIds = category.entity.fieldOptionsType.map(
          (optionType) => `${optionType.entity.tid}`
        );
        setTids(categoryIds.join("+"));
        setActiveFilters(categoryIds);
      } else {
        const categoryIds = category.entity.fieldOptionsType.map(
          (optionType) => `${optionType.entity.tid}`
        );
        setTids(categoryIds.join("+"));
        setBranchSchedulesVisibility(true);
      }
    }
    getBranches();
  };

  useEffect(() => {
    if (data && data.filtersByCountry.results.length !== 0) {
      setCategoryFilters(data.filtersByCountry.results[0].fieldAdvancedFilters);
    }
  }, [data, categoryFilters, setCategoryFilters]);

  useEffect(() => {
    if (queryResult.data && mapsInstance) {
      let { google } = mapsInstance;
      let queryCircle = new google.maps.Circle({
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        center: new google.maps.LatLng(initialPos),
        radius: radius,
      });
      let markers = [];
      queryResult.data.officeBranchesQuery.results.forEach((item) => {
        let location = new google.maps.LatLng({
          lat: item.fieldCoordinates.lat,
          lng: item.fieldCoordinates.lng,
        });
        let marker = new google.maps.Marker({
          position: location,
        });
        if (
          google.maps.geometry.spherical.computeDistanceBetween(
            marker.getPosition(),
            queryCircle.getCenter()
          ) <= queryCircle.getRadius()
        ) {
          markers.push(item);
        }
      });

      if (markers.length > 0) {
        setQueryState("success");
        setBranches(markers);
        setAdvancedFiltersVisibility(false);
        setMarkersVisibility(true);
        if (isResultView) {
          setResultsState(true);
          setFiltersVisibility(false);
          setCurrentPopUp(false);
        } else {
          if (tids === "") {
            setBranchSchedulesVisibility(false);
            setResultsState(false);
            setBranches([]);
            setMarkersVisibility(false);
            setCurrentPopUp(false);
          } else {
            setBranchSchedulesVisibility(true);
          }
        }
      } else {
        setQueryState("fails");
        setBranches([]);
        setCurrentPopUp(false);
      }
    }
  }, [
    tids,
    queryResult,
    mapsInstance,
    isResultView,
    initialPos,
    radius,
    setBranches,
    setFiltersVisibility,
    setResultsState,
    setMarkersVisibility,
    setCurrentPopUp,
    setAdvancedFiltersVisibility,
    setBranchSchedulesVisibility,
  ]);

  return (
    <div
      className={`service-type service-type${
        isResultView ? "--no-border" : ""
      }`}
    >
      <div className="service-type-header">
        <div>
          <h5>¿Cuál servicio requiere?</h5>
        </div>
        <button
          className="btn-no-style advanced-filter-container"
          onClick={(e) => {
            e.preventDefault();
            setAdvancedFiltersVisibility(!advancedFiltersVisibility);
            setBranchSchedulesVisibility(false);
            setCurrentPopUp(false);
          }}
        >
          <img
            className="advanced-filter-image"
            src="/modules/custom/bac_locations/js/src/assets/img/shape.svg"
            alt="Filter shape"
          />
          <span className="advanced-filter-label-sm">Filtrar</span>
          <span className="advanced-filter-label-md">
            Filtrar por tipo de servicio
          </span>
        </button>
      </div>
      <div
        className={`service-type-content service-type-content${
          isResultView ? "--small-item" : ""
        }`}
      >
        {categoryFilters &&
          categoryFilters.map((filterCategory, index) => (
            <button
              onClick={(e) => {
                e.preventDefault();
                handleService(filterCategory);
              }}
              className={`btn-no-style service-type-item service-type-item${
                isResultView ? "--small-item" : ""
              } ${
                filterCategory === categorySelected
                  ? "service-type-item--selected"
                  : ""
              }`}
              key={index}
            >
              <img
                className="service-type-image"
                src="/modules/custom/bac_locations/js/src/assets/img/office.svg"
                alt="Filter office"
              />
              <span className="service-type-label">
                {filterCategory.entity && filterCategory.entity.fieldGroupType}
              </span>
            </button>
          ))}
      </div>
      {isResultView && (
        <div className="service-type-result-label">
          <p className="service-type-result">Resultados</p>
        </div>
      )}
    </div>
  );
};
